import { useStreamDecks } from '@/routes/_app/use-stream-decks.ts';
import { CustomCollectionRef } from './use-add-targets-to-custom-collections.ts';

export type SubsetList = CustomCollectionRef & {
  name: string;
  deckName: string;
};

/**
 * Lists pinned to a subset of this stream's targets: the ones a new target
 * does not reach on its own.
 */
export const useSubsetLists = (
  streamId: string,
  excludeCollectionId?: string,
): SubsetList[] => {
  const streamDecks = useStreamDecks();
  const showDeckName = streamDecks.length > 1;

  return streamDecks.flatMap((deck) =>
    deck.collections
      .filter(
        (collection) =>
          collection.id !== excludeCollectionId &&
          collection.sourceConfigs.some(
            (config) => config.stream.id === streamId && !config.usesAllTargets,
          ),
      )
      .map((collection) => ({
        id: collection.id,
        streamDeckId: deck.id,
        name: collection.name,
        deckName: showDeckName ? deck.name : '',
      })),
  );
};
